export enum AIModel {
    OBJECT_DETECTION = "OBJECT_DETECTION",
    POSE_DETECTION = "POSE_DETECTION"
}